import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDividerModule } from '@angular/material/divider';

@Component({
  selector: 'app-shipment-configuration',
  imports: [
    MatIconModule,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    MatDividerModule,
    MatIconModule,
  ],
  templateUrl: './shipment-configuration.component.html',
  styleUrls: ['./shipment-configuration.component.css', '../../../shared/styles/layout.css'],
})
export class ShipmentConfigurationComponent {}
